import { createAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import productionHoursDataAccess from "src/dataAccess/procedures/productionHoursDataAccess";

export const LoadingProductionHours = createAction<boolean>("PRODUCTION_HOURS_LOADING");
export const GetProductionWeekScheduleSuccess = createAction<any>("GET_PRODUCTION_WEEK_SCHEDULE_SUCCESS");
export const SaveProductionWeekScheduleSuccess = createAction<any>("SAVE_PRODUCTION_WEEK_SCHEDULE_SUCCESS");

export const GetProductionWeekSchedule = (weekStartDate: string) => async (dispatch: Dispatch<any>) => {
    dispatch(LoadingProductionHours(true));
    return productionHoursDataAccess
        .getProductionWeekSchedule(weekStartDate)
        .then((res) => {
            dispatch(GetProductionWeekScheduleSuccess(res.data));
        })
        .finally(() => dispatch(LoadingProductionHours(false)));
};

export const SaveProductionWeekSchedule = (model: any) => async (dispatch: Dispatch<any>) => {
    return productionHoursDataAccess
        .saveProductionWeekSchedule(model)
        .then((res) => {
            dispatch(SaveProductionWeekScheduleSuccess(res.data));
        });
};